module.exports = (__webpack_require__(15))(30);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/object-assign/index.js from dll-reference vendor_library
// module id = 290
// module chunks = 0